import manager from 'app/module46/component-manager.js';

manager.register('flap', flap);

/**
 * @param {Element} component
 * @param {Object.<string, Element>} references
 * @param {Object.<string, string>} attributes
 * @param {Object.<string, string>} properties
 */
function flap(component, references, attributes, properties) {

	let isOpen = false;

	const {
		openBtn,
		closeBtn,
		content,
		zoomTemplateEl,
		chatTemplateEl
	} = references;

	const {
		contentUrl,
		alertUrl,
		timedOutUrl,
		createMessageUrl,
		zoomUrl,
		refuseCallUrl,
		acceptCallUrl,
		deleteMessagesUrl,
		refuseText,
		callingText,
		confirmButtonText,
		denyButtonText,
		addProductText,
		tableLinkText,
		removeProductUrl,
		timedOutText
	} = properties;

	const SECOND = 1000;
	const MINUTE = SECOND * 60;

	const regularRefreshTimer = MINUTE;
	const callBackTimer = 2 * SECOND;
	const CALL_TIMEOUT = 5 * MINUTE;
	let timeout;
	let { callBack } = properties;
	let callingStart = null;
	let isCalling = false;
	let xhr = new XMLHttpRequest();
	let type = null;
	let messageList = null;
	let chatTemplate = chatTemplateEl.innerHTML;
	let zoomTemplate = zoomTemplateEl.innerHTML;
	let bypass = null;
	let callbackModalShown = false;
	let activeTimer = (!!callBack) ?
		callBackTimer :
		regularRefreshTimer;

	openBtn.addEventListener('click', function () {
		if (!component.classList.contains('disabled') && !isOpen) {
			refreshFlap();
		}
	});

	closeBtn.addEventListener('click', function () {
		if (!component.classList.contains('disabled')) {
			closeFlap();
		}
	});

	function refreshFlap() {
		manager.get(contentUrl, (res) => {
			// Init content
			content.innerHTML = res;
			manager.execute(content);

			if (!isOpen) {
				// Open flap
				component.classList.add('flap--open');
				isOpen = true;
			}
		});
	}

	function closeFlap() {
		component.classList.remove('flap--open');
		isOpen = false;
	}

	function setFlapStatus(isDisabled) {
		if (isDisabled) {
			component.classList.add('disabled');
		} else {
			component.classList.remove('disabled');
		}
	}

	/**
	 * Define whether user is calling
	 * @param isCallingBool
	 * @param callingId
	 * @param typeVar
	 */
	function setCalling(isCallingBool, callingId = '', typeVar = null) {
		setCallingShort(isCallingBool, callingId, typeVar);

		if (isCallingBool) {
			callingStart = Date.now();

			Swal.fire({
				html:              callingText,
				showCloseButton:   true,
				showCancelButton:  false,
				showConfirmButton: false,
				allowOutsideClick: false,
				allowEscapeKey:    false,
				allowEnterKey:     false,
				didOpen:           () => {
					Swal.showLoading();
				}
			}).then(({ isDismissed }) => {
				if (isDismissed) {
					// Cancel Calling (flap.js)
					window.setCallingShort(false);

					// Activate callMe
					timedOut(callingId);
				}
			});
		}

		updateTimer();

		forceRefresh();
	}

	/**
	 *
	 * @param isCallingBool
	 * @param callingId
	 * @param typeVar
	 */
	function setCallingShort(isCallingBool, callingId = '', typeVar = null) {
		isCalling = isCallingBool;
		data.calling = callingId;
		type = typeVar;

		setFlapStatus(isCallingBool);
	}

	/**
	 * Define whether the user is expecting a call back
	 * @param callBackBool
	 */
	function setCallBack(callBackBool) {
		data.waiting_callback = callBack = callBackBool;

		updateTimer();

		forceRefresh();
	}

	/**
	 * Update which timer is used
	 */
	function updateTimer() {
		if (isCalling || data.waiting_callback || data.has_chat) {
			activeTimer = callBackTimer;
			return;
		}

		activeTimer = regularRefreshTimer;
		// TODO check regularTimerIsNeeded for anything
		//  Is there transaction notifications, do they need to be treated pronto?
	}

	/**
	 *
	 * @param hasChat
	 * @param id
	 */
	function setChat(hasChat, id = '') {
		data.has_chat = hasChat;
		data.chat_id = id;
		activeTimer = callBackTimer;
		forceRefresh();
	}

	function forceRefresh() {
		xhr.abort();
		clearTimeout(timeout);
		refreshAlert();
	}

	// Register functions on window
	window.setCalling = setCalling;
	window.setCallingShort = setCallingShort;
	window.setCallBack = setCallBack;
	window.closeFlap = closeFlap;
	window.refreshFlap = refreshFlap;
	window.setFlapStatus = setFlapStatus;
	window.setChat = setChat;
	window.forceRefresh = forceRefresh;


	/**
	 *
	 * @type {{has_chat: boolean, waiting_callback: boolean, last_message_id: string, calling: string, chat_id: string}}
	 */
	const data = {
		has_chat:         false,
		chat_id:          '',
		waiting_callback: !!callBack, // Type cast as boolean
		last_message_id:  '',
		calling:          ''
	}

	/**
	 * Core functionality of the timer
	 */
	function refreshAlert() {
		// Check talk alert needs to be shown
		xhr = manager.api(alertUrl, data, (res) => {
			let isContinue = true;

			if (isCalling) {
				const { accepted, product } = res;

				// If accepted !== null, call has been answered
				if (accepted !== null) {
					if (accepted) {
						const commId = data.calling;
						const { product } = res;
						const typeVar = type;

						// Turn off calling refresher
						setCalling(false);

						// Open call window
						startCommunication(commId, typeVar, product);

					} else {
						failCall();
					}

				} else if (Date.now() - callingStart >= CALL_TIMEOUT) {
					// If timed out
					let callingId = data.calling;

					// Short version of setCalling(false)
					setCallingShort(false);

					// Mark call as timed out
					timedOut(callingId);
				}

			} else {
				const { messages } = res;

				if (data.waiting_callback) {
					const {
						callingBackId,
						callingBackType,
						callingBackMessage,
						waitingCallBack,
						product
					} = res;

					data.waiting_callback = waitingCallBack;

					// Check if some reps are calling back
					//  If no modal is open, pull first rep and open modal
					//  All remaining reps have their calls cancelled. (* only one at a time)
					if (callingBackId) {
						if (Swal.isVisible() && bypass !== callingBackId) {
							manager.get(`${refuseCallUrl}/${callingBackId}`);

						} else {
							if (bypass === null) {
								bypass = callingBackId;

								// Show an accept / deny modal
								Swal.fire({
									text:           callingBackMessage,
									showDenyButton: true,
									confirmButtonText,
									denyButtonText
								}).then((result) => {

									if (result.isConfirmed) {
										manager.get(`${acceptCallUrl}/${callingBackId}`, () => {
											startCommunication(callingBackId, callingBackType, product);
										}, failCall);

									} else {
										manager.get(`${refuseCallUrl}/${callingBackId}`, failCall, failCall);
									}

									callbackModalShown = false;
									bypass = null;
								});
							}
						}
					} else if (bypass !== null) {
						manager.get(`${refuseCallUrl}/${callingBackId}`);
						Swal.fire('', timedOutText, 'warning');
						bypass = null;
					}
				}

				if (data.has_chat) {
					const { lines, lastMessageId } = res;

					if (lastMessageId) {
						data.last_message_id = lastMessageId;
					}

					renderLines(lines);
				}

				if (messages) {
					// If no modal open show messages and THEN delete them from DB
					const { messageIds } = res;

					if (!Swal.isVisible()) {
						let messageHtml = '';

						for (const messagesKey in messages) {
							messageHtml += messages[messagesKey] + '<br>';
						}

						Swal.fire({
							showCloseButton: true,
							html:            messageHtml,
						});

						isContinue = false;

						manager.api(deleteMessagesUrl, {
							messageIds
						}, null, null, () => {

							timeout = setTimeout(refreshAlert, activeTimer);
						});
					}
				}
			}

			if (isContinue) {
				timeout = setTimeout(refreshAlert, activeTimer);
			}
		}, () => {
			timeout = setTimeout(refreshAlert, activeTimer);
		});
	}

	refreshAlert();

	/**
	 * If timeout or refused
	 */
	function timedOut(callingId) {
		manager.api(timedOutUrl, {
			callingId,
		}, failCall, failCall);
	}

	function failCall() {
		// Send communication id to refresher (flap.js)
		setCallBack(true);

		// Short version of setCalling(false)
		setCallingShort(false);

		// Show callMeText message
		Swal.fire('', refuseText);
	}


	function startCommunication(id, type, product = null) {
		Swal.showLoading();

		if (type === 'chat') {
			startChat(id, product);
		} else {
			startZoom(id, product);
		}
	}

	function startChat(id, product = null) {
		let productEl = '';

		if (product !== null) {
			productEl = renderProductEl(product);
		}

		Swal.fire({
			html:              productEl + chatTemplate,
			showConfirmButton: product !== null,
			confirmButtonText: addProductText,
			showCloseButton:   true,
			allowOutsideClick: false,
			allowEscapeKey:    false,
			allowEnterKey:     false,

			/** @param {HTMLElement} popup */
			willOpen: (popup) => {
				messageList = $('.chat__messages');
				const input = popup.querySelector('.chat__input');
				const submit = popup.querySelector('.chat__submit');

				submit.addEventListener('click', send);
				input.addEventListener('keyup', function (e) {
					if (e.keyCode === 13) {
						send();
					}
				});

				function send() {
					const val = input.value;

					if (!val) {
						return true;
					}

					input.value = '';

					manager.api(createMessageUrl, { id, val }, forceRefresh);
				}

				setChat(true, id)
			}

		}).then((result) => {
			messageList = null;
			setChat();

			if (!result.isConfirmed) {
				removeProduct(product);
			}
		});
	}

	function startZoom(id, product = null) {
		const url = `${zoomUrl}/${id}`;
		let productEl = '';

		if (product !== null) {
			productEl = renderProductEl(product);
		}

		const regex = new RegExp("{url}", "gm");
		const html = productEl + zoomTemplate.replace(regex, url);

		Swal.fire({
			html,
			showCloseButton:   true,
			showConfirmButton: product !== null,
			confirmButtonText: addProductText,
			didOpen: (modal) => {
				manager.execute(modal);
			},
			allowOutsideClick: false,
			allowEscapeKey:    false,
			allowEnterKey:     false,
			customClass:       {
				popup: "contact-swal",
			},
		}).then((result) => {
			if (window.closeZoom) {
				window.closeZoom();
			}

			if (!result.isConfirmed) {
				removeProduct(product);
			}
		});
	}

	function renderLines(lines) {
		if (messageList) {
			for (const linesKey in lines) {
				$(lines[linesKey]).prependTo(messageList);
			}
		}
	}

	function renderProductEl(product) {
		return '<div class="product">'
			+ `<div><img class="product__img" src="${product.imageUrl}"></div>`
			+ `<div><small><a href="${product.tableUrl}" onclick="window.open('${product.tableUrl}', 'popup', 'width=800,height=450,scrollbars=no,resizable=no')" target="popup">${tableLinkText}</a></small></div>`
			+ '</div>';
	}

	function removeProduct(product) {
		if (product !== null) {
			manager.get(removeProductUrl);
		}
	}
}
